import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  header: {
    position: 'sticky',
    top: 0,
    left: 0,
    width: '100%',
    height: '56px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    background: '#fff',
    color: '#000',
    borderBottom: '1px solid rgba(149, 149, 149, 0.4)',
    zIndex: 100,
  },
  button: {
    color: '#F97F11',
  },
  text: {
    fontSize: '0.6rem',
    fontWeight: '400',
    textTransform: 'uppercase',
  },
});

export default useStyles;
